import { Suspense } from 'react';
import { useRouteLoaderData, Await, useActionData, useNavigation, Form, redirect, Link } from 'react-router-dom';
import Field from '../components/form/Field.jsx'
import Button from '../components/Button.jsx'
import { ListTournaments } from '../repo/TournamentsRepo.js'
import { CreateGroup } from '../repo/GroupsRepo.js';

function NewGroupPage() {
  const reponseData = useActionData()
  const signInNavigation = useNavigation()
  const isSubmitting = signInNavigation.state === 'submitting'
  const tournaments = useRouteLoaderData("group-new");

  return (
    <section>
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <p className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
          Novo Bolão
        </p>
        <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <Form method="POST" className="space-y-4 md:space-y-6">
              <Field type={"input"} name={"name"} id={"name"} label={"Nome"} required={""} maxLength={50}/>
              {reponseData && reponseData.errors && (
                <p>{reponseData.errors.detail}</p>
              )}

              <Suspense fallback={<p>Loading...</p>}>
                <Await resolve={tournaments}>
                  {(loadedTournaments) => <Field type={"select"} name={"tournament_id"} id={"tournament_id"} label={"Torneio"} required={""} options={loadedTournaments} />}
                </Await>
              </Suspense>

              <Button styleName="green" className="w-full" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </Button>

              <div className="text-center text-sm">
                <Link className="font-medium text-green-600 hover:underline" to={"/"}>Cancelar</Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NewGroupPage

export async function action({request}) {
  const data = await request.formData()

  const groupData = {
    group: {
      name: data.get('name').substring(0, 50),
      tournament_id: data.get('tournament_id'),
    }
  }

  const response = await CreateGroup(groupData)

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  return redirect('/')
}

async function loadTournaments() {
  const resData = await ListTournaments();

  return resData.data.map((tournament) => ({
      key: tournament.id,
      value: tournament.id,
      name: tournament.name + " " + tournament.edition
    }));
}

export async function loader() {
  return loadTournaments();
}
